import { render, staticRenderFns } from "./downArrowIconSvg.vue?vue&type=template&id=dffbb6c4&"
import script from "./downArrowIconSvg.vue?vue&type=script&lang=js&"
export * from "./downArrowIconSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports